import { MESSAGE_TYPES } from "../../../packages/constants";
import { BUTTON_TYPES } from "../types";
import type {
  Message,
  MessageText,
  MessageFile,
  MessageButtons,
  Button,
  ButtonLink,
  ButtonCallback,
} from "../types";

type ParamsMessage = Omit<Message, "replyMessage">;

export const isMessageText = (message: ParamsMessage): message is MessageText =>
  message.type === MESSAGE_TYPES.TEXT;

export const isMessageFile = (message: ParamsMessage): message is MessageFile =>
  message.type === MESSAGE_TYPES.FILE;

export const isMessageService = (
  message: ParamsMessage
): message is MessageText => message.type === MESSAGE_TYPES.SERVICE;

export const isMessageButtons = (
  message: ParamsMessage
): message is MessageButtons => message.type === MESSAGE_TYPES.BUTTONS;

export const isButtonLink = (button: Button): button is ButtonLink =>
  button.type === BUTTON_TYPES.LINK;

export const isButtonCallback = (button: Button): button is ButtonCallback =>
  button.type === BUTTON_TYPES.CALLBACK;
